export const aliasMap: Record<string, string> = {
    cmd: "meta",
    command: "meta",
    ctrl: "control",
    down: "arrowdown",
    left: "arrowleft",
    option: "alt",
    right: "arrowright",
    up: "arrowup",
};
